export const DEFAULT_FAV_SETTINGS_TAB = 'manageFavorites';
